import useBrainSearchBot from "@/admin/integrations/chat-bot/util/useBrainSearchBot"
import { ContentUsageBrainSearchButtonFragment$key } from "@/content-usage/drawer/__generated__/ContentUsageBrainSearchButtonFragment.graphql"
import { useGlobalDrawer } from "@/core/context/GlobalDrawerProvider"
import makeUseStyles from "@assets/style/util/makeUseStyles"
import { DiscoIcon, DiscoIconButton } from "@disco-ui"
import {
  OverridableDiscoButton,
  OverridableDiscoButtonChildren,
} from "@disco-ui/button/OverridableDiscoButton"
import { TestIDProps } from "@utils/typeUtils"
import { graphql, useFragment } from "react-relay"

type Props = TestIDProps & {
  contentUsageKey: ContentUsageBrainSearchButtonFragment$key
  children?: OverridableDiscoButtonChildren
}

function ContentUsageBrainSearchButton(props: Props) {
  const { testid = "ContentBrainSearchButton", contentUsageKey, children } = props
  const brainSearchBot = useBrainSearchBot()
  const drawer = useGlobalDrawer("brainSearch")
  const classes = useStyles()

  const contentUsage = useFragment<ContentUsageBrainSearchButtonFragment$key>(
    graphql`
      fragment ContentUsageBrainSearchButtonFragment on ContentUsage {
        id
        content {
          type
        }
      }
    `,
    contentUsageKey
  )

  // Don't show if bot is not active or this isn't a lesson (text/video)
  if (
    brainSearchBot?.status !== "active" ||
    (contentUsage.content.type !== "text" && contentUsage.content.type !== "video")
  )
    return null

  // Don't show if the side panel is already open
  if (drawer.params.drawerAsk) return null

  return (
    <OverridableDiscoButton onClick={handleClick}>
      {children ??
        ((btnProps) => (
          <DiscoIconButton
            {...btnProps}
            testid={testid}
            tooltip={brainSearchBot.name}
            width={40}
            height={40}
            className={classes.brainSearchButton}
          >
            <DiscoIcon icon={"stars"} width={20} height={20} />
          </DiscoIconButton>
        ))}
    </OverridableDiscoButton>
  )

  function handleClick() {
    drawer.setParams({ drawerAsk: "1", sourceId: contentUsage.id })
  }
}

const useStyles = makeUseStyles((theme) => ({
  brainSearchButton: {
    padding: theme.spacing(1.25),
  },
}))

export default ContentUsageBrainSearchButton
